import { message, Modal, Table } from 'antd';
import { PaginationProps } from 'antd/lib/pagination';
import { ColumnProps } from 'antd/lib/table';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Dispatch } from 'redux';
import DrugStoreSearch from 'src/components/custom/DrugStoreSearch';
import { IPageResult } from 'src/entity/BaseResult';
import { IDrugStoreInfo, ISubDrugStore } from 'src/entity/DrugStoreEntity';
import { IDrugStoreListColumnData } from 'src/entity/ColumnDataEntity';
import { IDrugStoreSearch } from 'src/entity/SearchEntity';
import { reloadDrugStores } from 'src/redux/actions/drugStoreCreator';
import DrugStoreService from 'src/services/DrugStoreService';
import FileService from 'src/services/FileService';
import I18N from 'src/services/I18NService';
import { IStateCollection } from 'src/entity/StateEntity';

const confirm = Modal.confirm;

interface IDrugStoreListPageProps extends RouteComponentProps {
  drugStores: IDrugStoreInfo[];
  isDomestic: boolean;
  dispatch: Dispatch<IStateCollection>;
}

interface IDrugStoreListPageState {
  loadingTable: boolean;
  columns: Array<ColumnProps<IDrugStoreListColumnData>>;
  dataSource: IDrugStoreListColumnData[];
  pagination: PaginationProps;
}

class DrugStoreListPage extends React.Component<IDrugStoreListPageProps, IDrugStoreListPageState> {
  tablePagination = false;
  canSubmit = true;
  child: any;

  constructor(props: IDrugStoreListPageProps) {
    super(props);

    const columns: Array<ColumnProps<IDrugStoreListColumnData>> = [
      {
        title: I18N.get('common_rowNum'),
        key: 'index',
        dataIndex: 'index',
      },
      {
        title: I18N.get('drug_store_name'),
        key: 'name',
        dataIndex: 'name',
      },
      {
        title: I18N.get('common_full_address'),
        key: 'address',
        dataIndex: 'address',
      },
      {
        title: I18N.get('common_admin'),
        key: 'admin_name',
        dataIndex: 'admin_name',
      },
      {
        title: I18N.get('login_userName'),
        key: 'admin_username',
        dataIndex: 'admin_username',
      },
      {
        title: I18N.get('common_mobile'),
        key: 'admin_mobile',
        dataIndex: 'admin_mobile',
      },
      {
        title: 'email',
        key: 'admin_email',
        dataIndex: 'admin_email',
      },
      {
        title: I18N.get('common_status'),
        key: 'is_active_desc',
        dataIndex: 'is_active_desc',
      },
      // {
      //   title: I18N.get('common_operation'),
      //   dataIndex: 'operation',
      //   key: 'operation',
      //   render: (text: any, record: IDrugStoreListColumnData, index: number): React.ReactNode => {
      //     return this.state.dataSource.length > 0 ? (
      //       <div>
      //         {!record.is_active && (
      //           <a onClick={() => this.handleChangeStatus(record, true)}>&nbsp;&nbsp;{I18N.get('common_status_start')}</a>
      //         )}
      //         {!!record.is_active && (
      //           <a onClick={() => this.handleChangeStatus(record, false)}>&nbsp;&nbsp;{I18N.get('common_status_stop')}</a>
      //         )}
      //         <a onClick={() => this.handleDelete(record)}>&nbsp;&nbsp;{I18N.get('common_delete')}</a>
      //       </div>
      //     ) : null;
      //   },
      // },
    ];

    this.state = {
      loadingTable: false,
      columns,
      dataSource: [],
      pagination: {},
    } as IDrugStoreListPageState;
  }

  componentDidMount() {
    this.child.doSearch();
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  onRefAuditSearch = (ref: any) => {
    this.child = ref;
  };

  handleSearch = (result: IPageResult<IDrugStoreInfo[]>) => {
    this.setState({
      loadingTable: true,
    });
    const dataList: IDrugStoreListColumnData[] = [];
    const pagination: PaginationProps = { ...this.state.pagination };
    if (!!result && !!result.results) {
      pagination.total = result.count;
      if (!this.tablePagination) {
        pagination.current = 1;
      }
      for (let i = 0, len = result.results.length; i < len; i++) {
        const obj: IDrugStoreInfo = result.results[i];
        dataList.push({
          key: obj.id,
          index: !!pagination.pageSize ? i + 1 + (Number(pagination.current) - 1) * pagination.pageSize : i + 1,
          name: obj.name,
          address: obj.address,
          admin_mobile: obj.admin_mobile,
          admin_email: obj.admin_email || '',
          location: obj.location,
          admin_username: obj.admin_username,
          is_active: obj.is_active,
          is_active_desc: !obj.is_active ? I18N.get('common_status_stop') : I18N.get('common_status_start'),
          admin_name: obj.admin_name,
          drugStoreObj: obj,
        });
      }
    }
    this.setState({
      dataSource: dataList,
      loadingTable: false,
      pagination,
    });
    this.tablePagination = false;
  };

  handleDrugStoreExport = async () => {
    try {
      const pagination: PaginationProps = { ...this.state.pagination };
      const query: IDrugStoreSearch = {
        limit: pagination.total,
        offset: 0,
      };
      const res: IPageResult<IDrugStoreInfo[]> = await DrugStoreService.getDrugStore(query);
      if (!!res && !!res.results) {
        FileService.drugStoreExport(res.results, this.props.isDomestic);
      }
    } catch (error) {
      if (!!error.response) {
        message.error(JSON.stringify(error.response.data));
      } else {
        message.error(I18N.get('err_save_failure'));
      }
    }
  };

  handleDrugStoreAdd = () => {
    const { match } = this.props;
    this.props.history.push(`${match.path}/add`);
  };

  handleChangeStatus = (record: IDrugStoreListColumnData, isActive: boolean) => {
    confirm({
      title: `${I18N.get('common_sure')}${isActive ? I18N.get('common_status_start') : I18N.get('common_status_stop')}${I18N.get('drug_store_current')}?`,
      content: ``,
      okText: `${isActive ? I18N.get('common_status_start') : I18N.get('common_status_stop')}`,
      cancelText: I18N.get('common_cancel'),
      onOk: async () => {
        try {
          const data: ISubDrugStore = {
            is_active: isActive,
          };
          await DrugStoreService.updateDrugStore(data, record.key);
          this.child.doSearch();
        } catch (error) {
          if (!!error.response) {
            message.error(JSON.stringify(error.response.data));
          } else {
            message.error(I18N.get('err_save_failure'));
          }
        }
      },
      onCancel() {},
    });
  };

  handleDelete = async (record: IDrugStoreListColumnData) => {
    confirm({
      title: `${I18N.get('common_sure')}${I18N.get('common_delete')}${I18N.get('drug_store_current')}?`,
      content: `${I18N.get('doc_warning_undone')}`,
      okText: `${I18N.get('common_delete')}`,
      cancelText: I18N.get('common_cancel'),
      onOk: async () => {
        try {
          await DrugStoreService.deleteDrugStore(record.key);
          // 设置配药中心reload为true
          this.props.dispatch(reloadDrugStores());
          this.child.doSearch();
        } catch (error) {
          if (!!error.response) {
            message.error(JSON.stringify(error.response.data));
          } else {
            message.error(I18N.get('err_save_failure'));
          }
        }
      },
      onCancel() {},
    });
  };

  handleTableOnChange = (pagination: PaginationProps, filters: any, sorter: any) => {
    this.tablePagination = true;
    const pager: PaginationProps = { ...this.state.pagination };
    pager.current = pagination.current;
    pager.pageSize = pagination.pageSize;
    this.setState({
      pagination: pager,
    });
    if (!!pager.current && Number(pager.current) > 0) {
      this.child.doSearch((pager.current - 1) * Number(pagination.pageSize), pagination.pageSize);
    }
  };

  render() {
    return (
      <div>
        <DrugStoreSearch onRef={this.onRefAuditSearch} cbSearch={this.handleSearch} />
        {/* <div style={{ margin: '24px', textAlign: 'right' }}>
          <Button type="default" onClick={this.handleDrugStoreExport}>
            <Icon type="download" />
            {I18N.get('common_data_export')}
          </Button>
          &nbsp;&nbsp;
          <Button type="primary" onClick={this.handleDrugStoreAdd} loading={this.state.loadingTable}>
            <Icon type="form" />
            {I18N.get('common_new')}
          </Button>
        </div> */}
        <Table
          style={{ marginTop: 15 }}
          loading={this.state.loadingTable}
          columns={this.state.columns}
          pagination={this.state.pagination}
          dataSource={this.state.dataSource}
          onChange={this.handleTableOnChange}
        />
      </div>
    );
  }
}

export default DrugStoreListPage;



// WEBPACK FOOTER //
// ./src/components/views/DrugStore/DrugStoreListPage.tsx